import { ActionTypes as FileActionTypes } from "./constants";

const INIT_STATE = {
    loading: true,
    files: {},
    error: {},
    success: false,
    message: null,
    tag: {},
    filterFiles: {},
    singleFile: {},
    delSuccess: false
}


type ActionTypes = {
    type:
    | FileActionTypes.FETCH_FILES
    | FileActionTypes.SET_FILES
    | FileActionTypes.SET_ERROR
    | FileActionTypes.UPLOAD_FILE
    | FileActionTypes.UPLOAD_FILE_SUCCESS
    | FileActionTypes.UPLOAD_FILE_FAIL
    | FileActionTypes.DOWNLOAD_FILE_BY_ID
    | FileActionTypes.DOWNLOAD_FILE_BY_PATH
    | FileActionTypes.DOWNLOAD_FILE_SUCCESS
    | FileActionTypes.DOWNLOAD_FILE_FAIL
    | FileActionTypes.DELETE_FAIL
    | FileActionTypes.DELETE_SUCCESS
    | FileActionTypes.DELETE_FAIL
    | FileActionTypes.SET_TAG
    | FileActionTypes.RESET
    | FileActionTypes.SET_FILES_BY_ID
    | FileActionTypes.RESET_FILE_SUCCESS
    payload: {
        actionType?: string;
        data?: {},
        error?: {},
    }
}



const FilesReducer = (state: any = INIT_STATE, actionTypes: ActionTypes) => {
    switch (actionTypes.type) {
        case FileActionTypes.SET_FILES:
            return { ...state, files: actionTypes.payload.data, loading: false, success: false, error: {}, message: "" }
        case FileActionTypes.SET_FILES_BY_ID:
            return { ...state, filterFiles: actionTypes.payload.data, loading: false, success: false, error: {}, message: "", files: {} }
        case FileActionTypes.SET_TAG:
            return { ...state, tag: actionTypes.payload.data, loading: false, success: false, error: {}, message: "" }
        case FileActionTypes.UPLOAD_FILE_SUCCESS:
            return { ...state,success:true, message: "File uploaded successfully", singleFile: actionTypes.payload.data, error: {}, delSuccess: false }
        case FileActionTypes.DELETE_SUCCESS:
            return { ...state, success: true, message: "File deleted successfully", error: {}, delSuccess: true }
        case FileActionTypes.DELETE_FAIL:
            return { ...state, success: false, message: "", error: { message: "Won't be able to delete file" } }
        case FileActionTypes.UPLOAD_FILE_FAIL:
            return { ...state, success: false, message: "", error: { message: "file upload failed" } }
        case FileActionTypes.DOWNLOAD_FILE_SUCCESS:
            return { ...state, success: false, message: "File downloaded successfully", error: {}, delFalse: false }
        case FileActionTypes.DOWNLOAD_FILE_FAIL:
            return { ...state, success: false, message: "", error: { message: "File download failed" } }
        case FileActionTypes.SET_ERROR:
            return { ...state, files: {}, error: actionTypes.payload.error, success: false, message: "" }
        case FileActionTypes.RESET_FILE_SUCCESS:
            console.log("reset");
            
            return { ...state,success:false,message: "" }
                case FileActionTypes.RESET:
            return INIT_STATE
        default:
            return { ...state }
    }
}

export default FilesReducer;